import { TSetCompleteGameResponse } from './types';
import { IApplicationContext } from 'shared/types/applicationContext';

type TParams = {
  context: Pick<IApplicationContext, 'custom' | 'httpApi'>;
  doorId: string;
};

export const setDoorCompletedV1Info = async ({
  context: {
    httpApi,
    custom: { cianUserId },
  },
  doorId,
}: TParams): Promise<TSetCompleteGameResponse> => {
  const { statusCode, response } = await httpApi.fetch({
    apiType: 'external',
    microserviceName: 'info-api',
    assertStatusCodes: [200, 400],
    method: 'POST',
    requestContentType: 'json',
    pathApi: '/api/advent/v1/set-door',
    parameters: { userId: cianUserId, door: doorId },
  });

  return { statusCode, response } as TSetCompleteGameResponse;
};
